import React from "react";
import { withI18n } from "react-i18next";
import styled from "styled-components";
import { Button, ButtonGroup, Typography } from "../../../Common";
import { IAuditionQuestion } from "../../../../interfaces/IAuditionQuestion";
import PlusBlue from "../../../../images/plus-blue.svg";

const QuestionMaxLength = 144;

const QuestionMaxCount = 6;

const QuestionsAddEditSection = (props: {
  t: any;
  showAddEditQuestions: boolean;
  auditionQuestions: IAuditionQuestion[];
  onShowAddEditQuestions: () => void;
  onAddSingleQuestion: () => void;
  onRemoveQuestion: (q: IAuditionQuestion) => void;
  onCancel: () => void;
  onSaveQuestions: () => void;
  onChangeQuestion: (e: any, q: IAuditionQuestion) => void;
}) => {
  const {
    t,
    auditionQuestions,
    onRemoveQuestion,
    onCancel,
    onSaveQuestions,
    onChangeQuestion,
    onAddSingleQuestion,
  } = props;

  const activeAuditionQuestions = auditionQuestions && auditionQuestions.filter(
    (x) => x.status === true
  );

  return (
    <StyledSection>
      <Typography
        color="inherit"
        gutterBottom
        variant="h4"
      >
        {t("Enter the questions you would like to ask talent in the spaces provided. You may ask up to 6 Custom Questions.")}
      </Typography>
      <form>
        {activeAuditionQuestions.map((q, index) => (
          <div className="form-group row" key={index + 1}>
            <div className="col-12">
              <label>{`${t("Question")} ${index + 1}`}</label>
              <input
                type="text"
                className="form-control input-question"
                placeholder={t("Begin entering question here")}
                maxLength={QuestionMaxLength}
                value={q.question ? q.question : ""}
                onChange={(e) => onChangeQuestion(e, q)}
              />
              <span
                className="icon-cwb-remove icon-remove-red"
                onClick={() => onRemoveQuestion(q)}
              ></span>
              <small className="form-text text-muted float-right small-pad-right">{`${QuestionMaxLength} characters max`}</small>
            </div>
          </div>
        ))}
        {activeAuditionQuestions &&
            activeAuditionQuestions.length < QuestionMaxCount && (
              <div style={{ cursor: "pointer" }} onClick={onAddSingleQuestion}>
                <StyledImgIcon src={PlusBlue} />
                <SpanAddQuestion>{t("Add another question")}</SpanAddQuestion>
              </div>
            )}
        <div className="form-group row">
          <div className="col-12">
            <StyledButtonGroup>
              <Button onClick={onSaveQuestions}>
                {t("Save")}
              </Button>
              <Button
                variant="secondary"
                onClick={onCancel}
              >
                {t("Cancel")}
              </Button>
            </StyledButtonGroup>
          </div>
        </div>
      </form>
    </StyledSection>
  );
};

const StyledSection = styled.section`
  margin: ${p => p.theme.spacing(4, 0, 0, 0)};
`;

const SpanAddQuestion = styled.span`
  margin-left: 5px;
  color: #00aaff;
`;

const StyledImgIcon = styled.img`
  padding-bottom: 2px;
`;

const StyledButtonGroup = styled(ButtonGroup)`
  margin: ${p => p.theme.spacing(2, 0, 0, 0)};
`;

export default withI18n()(QuestionsAddEditSection);
